export type IFlyerSliderResources = typeof FlyerSliderResources;

export const FlyerSliderResources = {
    noFlyersFound: "Produkt nie został znaleziony",
};
